<template>
  <c-modal
    v-model:open="show"
    size="300"
  >
    <div
      v-if="confirmation"
      :class="b()"
    >
      <h2>
        {{ confirmation.title }}
      </h2>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="confirmation.message"></div>
      <div :class="b('actions')">
        <e-button
          :class="b('action')"
          :progress="coursesStore.runningRequests.apiBookCourse"
          :width="$viewport.isSm ? 'auto' : 'full'"
          variant="primary"
          spacing="600"
          @click="onClose"
        >
          {{ $t('c-course-booking.close') }}
        </e-button>
      </div>
    </div>
    <div
      v-else
      :class="b()"
    >
      <h2>
        {{ $t('c-course-booking.title') }}
      </h2>
      <p>
        {{ $t('c-course-booking.message') }}
      </p>

      <dl
        v-if="!coursesStore.bookingCourse.isPriceOnDemand"
        :class="b('info-list')"
      >
        <dt :class="b('info-term')">
          {{ $t('c-course-booking.coursePrice') }}
        </dt>
        <dd :class="b('info-description')">
          {{
            coursesStore.bookingCourse.isFreeCourse
              ? $t('c-course-booking.freeOfCharge')
              : coursesStore.bookingCourse.price
          }}
        </dd>
      </dl>

      <p v-else>
        {{ $t('c-course-price.onDemandLongText') }}
      </p>

      <p
        v-if="!coursesStore.bookingCourse.isFreeCourse"
        :class="b('legal-notice')"
      >
        {{ $t('c-course-booking.legalNotice') }}
      </p>
      <div :class="b('actions')">
        <e-button
          :class="b('action')"
          :progress="coursesStore.runningRequests.apiBookCourse"
          :width="$viewport.isSm ? 'auto' : 'full'"
          variant="primary"
          spacing="600"
          @click="onSubmit"
        >
          {{ $t('c-course-booking.confirm') }}
        </e-button>
      </div>
    </div>
  </c-modal>
</template>

<script>
  import { BOOKING_STATUS_MAP } from '@/setup/globals';
  import useCoursesStore from '@/stores/courses';
  import useSessionStore from '@/stores/session';
  import cModal from '@/components/c-modal.vue';
  import eButton from '@/elements/e-button.vue';

  /**
   * Renders a course booking modal.
   *
   * **WARNING: uses 'v-html' for the success message. Make sure, that the source for this data is trustworthy.**
   */
  export default {
    name: 'c-course-booking',

    components: {
      eButton,
      cModal,
    },
    // mixins: [],

    // props: {},
    setup() {
      return {
        sessionStore: useSessionStore(),
        coursesStore: useCoursesStore(),
      };
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Handles the modal state.
       *
       * @returns {Boolean}
       */
      show: {
        get() {
          return !!this.coursesStore.bookingCourse;
        },
        set(show) {
          if (!show) {
            this.coursesStore.bookingCourse = null;
          }
        },
      },

      /**
       * Returns an object of confirmation messages based on the type of confirmation.
       *
       * @returns {Object|null}
       */
      confirmation() {
        switch (this.coursesStore.getBooking?.status) {
          case BOOKING_STATUS_MAP.APPROVED:
            return {
              title: this.$t('c-course-booking.confirmationTitle'),
              message: this.$t('c-course-booking.confirmationMessage'),
            };

          case BOOKING_STATUS_MAP.WAITING_LIST:
            return {
              title: this.$t('c-course-booking.waitingListConfirmationTitle'),
              message: this.$t('c-course-booking.waitingListConfirmationMessage'),
            };

          default:
            return null;
        }
      },
    },
    watch: {
      /**
       * Observers booking and closes modal in cases where we don't show a confirmation in the modal.
       */
      'coursesStore.getBooking.status': {
        handler(status) {
          if (![BOOKING_STATUS_MAP.WAITING_LIST, BOOKING_STATUS_MAP.APPROVED].includes(status)) {
            this.onClose();
          }
        },
      },
    },

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      /**
       * Handles the submit button event.
       */
      onSubmit() {
        const courseId = this.coursesStore.bookingCourse.id;
        const customerId = this.sessionStore.user.uid;

        this.$gtm.pushCourseBooking();

        this.coursesStore.apiBookCourse({ courseId, customerId });
      },

      /**
       * Handles the close button event.
       */
      onClose() {
        this.show = false;
      },
    },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-course-booking {
    &__info-list,
    &__legal-notice {
      margin-top: functions.rem(variables.$spacing--40);
    }

    &__info-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__info-term,
    &__info-description {
      margin: 0;
      font-weight: variables.$font-weight--regular;
    }

    &__info-term {
      grid-column: 1;
      grid-row: 1;
    }

    &__info-description {
      grid-column: 2;
      grid-row: 1;
      text-align: right;

      @include mixins.media(sm) {
        text-align: left;
      }
    }

    &__actions {
      display: flex;
      justify-content: flex-end;
      margin-top: functions.rem(variables.$spacing--40);
    }
  }
</style>
